import { createFileRoute } from '@tanstack/react-router';
import { ProcessDetailPage } from '@/pages/processes/all-processes/ProcessDetailPage';
import { createEntityBreadcrumbLoader } from '@/lib/entity-breadcrumb';
import { dataTableSearchSchema } from '@/lib/validation/dataTableSearchSchema';

export const Route = createFileRoute('/$slug/processes/all-processes/$processId/')({
  // The step table persists its filter/sort/visibility state in namespaced URL
  // params (`process-steps_*`); the catchall hands them through.
  validateSearch: dataTableSearchSchema({}),
  loader: createEntityBreadcrumbLoader('process', 'processId'),
  component: RouteComponent
});

function RouteComponent() {
  const { processId } = Route.useParams();
  return <ProcessDetailPage processId={processId} />;
}
